<template>
  <asc-dialog
    class="asc-selection-dialog--container"
    :show-title="false"
    :show-dialog="showDialog"
    :on-close="handleClose"
    :width="435"
  >
    <template v-if="showDialog">
      <div class="asc-selection--container">
        <div v-if="title || subtitle" class="asc-selection--header">
          <h1 v-if="title" class="title">{{ title }}</h1>
          <p v-if="subtitle" class="subtitle">{{ subtitle }}</p>
        </div>
        <div class="asc-selection--options">
          <div
            v-for="(type, key, index) in definition"
            :key="index"
            class="asc-selection--option"
          >
            <asc-accent-button
              :block="true"
              :on-click="handleClick"
              :button-text="type.name"
              secondary
            ></asc-accent-button>
            <asc-label
              v-if="type.description"
              size="md"
              :value="type.description"
              class="description"
            ></asc-label>
          </div>
        </div>
      </div>
    </template>
  </asc-dialog>
</template>

<script>
import { AscDialogMixin } from '@/components/mixins'
import AscDialog from '@/components/atoms/AscDialog'
import AscAccentButton from '@/components/atoms/AscAccentButton'
import AscLabel from '@/components/atoms/AscLabel'

export default {
  name: 'AscSelectionDialog',

  components: {
    AscDialog,
    AscAccentButton,
    AscLabel,
  },

  mixins: [AscDialogMixin],

  props: {
    title: {
      type: String,
      required: true,
    },
    subtitle: {
      type: String,
      default: null,
    },
    definition: {
      type: Array,
      required: true,
    },
    onSelection: {
      type: Function,
      default: () => {},
    },
  },

  data() {
    return {
      selectedType: null,
    }
  },

  methods: {
    handleClick(e, value) {
      const selectedObj = this.definition.find(type => type.name === value)

      if (selectedObj) {
        this.handleClose()
        this.$emit('input', selectedObj)
        if (this.onSelection) {
          this.onSelection(selectedObj)
        }
      }
    },
  },
}
</script>

<style lang="scss">
.asc-selection-dialog--container {
  .asc-dialog {
    .v-card {
      &__title {
        padding-bottom: 0 !important;
        height: 0;

        .asc-close-button {
          right: -2px;
          top: -3px;

          .v-icon {
            color: $primary-black !important;
            font-weight: bold;
          }
        }
      }

      &__text {
        padding-bottom: 16px !important;

        .asc-selection {
          &--header {
            margin-bottom: 35px;
            padding: 8px 25px 0 8px;

            .title {
              color: $primary-black;
              font-size: $font-size-md !important;
              font-weight: 500;
              letter-spacing: 1px !important;
              line-height: 18px;
              margin: 0 0 14px 0;
              text-transform: uppercase;
            }

            .subtitle {
              color: $gray-1000;
              font-size: $font-size-md;
              letter-spacing: 0;
              line-height: 18px;
              margin: 0;
            }
          }

          &--options {
            .asc-selection--option {
              background-color: $gray-200;
              margin-bottom: 1px;
              padding: 20px 16px 18px 16px;

              .asc-label.description {
                margin: 14px 0 0 0;
                line-height: 18px;
                display: block;
                text-align: center;
              }

              &:last-child {
                margin-bottom: 0;
              }
            }
          }
        }
      }
    }
  }
}
</style>
